import { defineStore } from "pinia";
import { createBaseStore } from "~/stores/base";

const base = createBaseStore("filters");

export const useFiltersStore = defineStore("filters", {
  state: () => ({
    ...base.state,
    results: {},
  }),

  actions: {
    ...base.actions,

    async replaceFilter(resource) {
      const { $api } = useNuxtApp();
      const response = await $api.get(`filters/${resource}`);
      this.results[resource] = response?.data;
    },
  },
});
